enum CurvaABCConsiderar {
    Consumo = 1,
    ValorDeVenda = 2,
}

export default CurvaABCConsiderar;
